import {getUseQueryResultData} from "../../../util/selector-util";
import {createSelector} from "@reduxjs/toolkit";
import {
    AllocatableLoadInventorySnapshot,
    AllocatableLoadInventorySnapshotEntity
} from "../../../model/allocatable-load-inventory-snapshot";

export type AllocatableLoadInventorySnapshotSelectorProps = {
    // selector props
};

export const allocatableLoadInventoriesSelector = () => createSelector(
    [getUseQueryResultData<AllocatableLoadInventorySnapshot[]>],
    (data) => {
        return selectAllocatableLoadInventorySnapshotsAndTransform(
            data ?? [], {});
    }
);

export const allocatableLoadInventorySelector = () => createSelector(
    [getUseQueryResultData<AllocatableLoadInventorySnapshot>],
    (data) => {
        return data ? transformAllocatableLoadInventorySnapshot(data) : undefined;
    }
);

export const selectAllocatableLoadInventorySnapshots = (values?: AllocatableLoadInventorySnapshot[], selector?: AllocatableLoadInventorySnapshotSelectorProps): AllocatableLoadInventorySnapshot[] => {
    if (!values) {
        return [];
    }

    return values.filter((v) => {
        let filterIn = true;
        return filterIn;
    });
};

export const transformAllocatableLoadInventorySnapshot = (value: AllocatableLoadInventorySnapshot): AllocatableLoadInventorySnapshotEntity => {
    return AllocatableLoadInventorySnapshotEntity.from(value)
}

export const selectAllocatableLoadInventorySnapshotsAndTransform = (values?: AllocatableLoadInventorySnapshot[], selector?: AllocatableLoadInventorySnapshotSelectorProps): AllocatableLoadInventorySnapshotEntity[] => {
    const selected = selectAllocatableLoadInventorySnapshots(values, selector);
    return selected.map(transformAllocatableLoadInventorySnapshot);
};
